module.exports = __webpack_public_path__ + "img/files_active.22cde5ee.svg";